import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import toast from 'react-hot-toast';
import { emailStorage } from '../utils/emailStorage';

const EmailCapture = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    
    // Simulate network delay for better UX
    setTimeout(() => {
      const result = emailStorage.add(email);
      
      if (result.success) {
        toast.success(result.message);
        setEmail('');
      } else {
        toast.error(result.message);
      }
      
      setIsSubmitting(false);
    }, 800);
  };

  return (
    <section 
      id="notify"
      className="relative py-32 px-6 bg-slate-900"
      data-component-path="client/src/components/EmailCapture.jsx"
      data-component-line="1:5"
      data-component-id="client/src/components/EmailCapture.jsx:1:5"
    >
      <div 
        className="max-w-2xl mx-auto text-center"
        data-component-path="client/src/components/EmailCapture.jsx"
        data-component-line="2:7"
        data-component-id="client/src/components/EmailCapture.jsx:2:7"
      >
        <div 
          className="mb-8"
          data-component-path="client/src/components/EmailCapture.jsx"
          data-component-line="3:9"
          data-component-id="client/src/components/EmailCapture.jsx:3:9"
        >
          <Mail 
            className="w-16 h-16 mx-auto text-slate-400 mb-6"
            data-component-path="client/src/components/EmailCapture.jsx"
            data-component-line="4:11"
            data-component-id="client/src/components/EmailCapture.jsx:4:11"
          />
          <h2 
            className="text-4xl md:text-5xl font-bold text-slate-100 mb-4 tracking-tight"
            data-component-path="client/src/components/EmailCapture.jsx"
            data-component-line="5:11"
            data-component-id="client/src/components/EmailCapture.jsx:5:11"
          >
            Be the First to Know
          </h2>
          <p 
            className="text-lg text-slate-400 font-light"
            data-component-path="client/src/components/EmailCapture.jsx"
            data-component-line="6:11"
            data-component-id="client/src/components/EmailCapture.jsx:6:11"
          >
            Join the waitlist for exclusive early access and launch updates.
          </p>
        </div>

        <form 
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
          data-component-path="client/src/components/EmailCapture.jsx"
          data-component-line="7:9"
          data-component-id="client/src/components/EmailCapture.jsx:7:9"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 h-14 px-6 bg-slate-800 border border-slate-700 text-slate-100 placeholder-slate-500 rounded-none focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-transparent transition-all"
            required
            data-component-path="client/src/components/EmailCapture.jsx"
            data-component-line="8:11"
            data-component-id="client/src/components/EmailCapture.jsx:8:11"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="h-14 px-8 bg-slate-100 text-slate-950 font-semibold rounded-none hover:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 shadow-lg hover:shadow-xl focus:ring-4 focus:ring-slate-400/50 flex items-center justify-center gap-2"
            data-component-path="client/src/components/EmailCapture.jsx"
            data-component-line="9:11"
            data-component-id="client/src/components/EmailCapture.jsx:9:11"
          >
            {isSubmitting ? 'Joining...' : 'Notify Me'}
          </button>
        </form>

        <p 
          className="mt-6 text-sm text-slate-500"
          data-component-path="client/src/components/EmailCapture.jsx"
          data-component-line="10:9"
          data-component-id="client/src/components/EmailCapture.jsx:10:9"
        >
          No spam. Just updates on our launch and exclusive early access.
        </p>
      </div>
    </section>
  );
};

export default EmailCapture;